var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEval(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #323232;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.5px;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.39,19.69c-1.73,1.44-3.96,2.31-6.39,2.31-2.19,0-4.23-.71-5.87-1.91l2.37-2.37c1.02.65,2.24,1.01,3.53,1.01,1.51,0,2.91-.5,4.04-1.35l2.32,2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.39,4.3l-2.29,2.29c-1.13-.87-2.55-1.38-4.07-1.38-1.31,0-2.53.37-3.56,1.03l-2.34-2.34c1.64-1.2,3.68-1.9,5.87-1.9,2.43,0,4.66.86,6.39,2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.28,15.5l-2.37,2.37c-1.2-1.65-1.91-3.68-1.91-5.87s.71-4.23,1.92-5.87l2.34,2.34c-.63,1.02-.99,2.23-.99,3.5s.36,2.51,1.01,3.53Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.88,12.1c0,2.05-1.66,3.7-3.7,3.7s-3.7-1.66-3.7-3.7,1.66-3.7,3.7-3.7c.32,0,.63.04.93.12"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "12.02 11.55 13.14 12.67 16.47 9.35"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEval);
export default __webpack_public_path__ + "static/media/Eval.04a6ce89af1419c084954028ddc5926f.svg";
export { ForwardRef as ReactComponent };